import { useState } from "react";
import { Button } from "@design-lab/shared/ui";
import { Shirt } from "lucide-react";
import { ProductBrowser } from "@design-lab/widgets/product-browser";
import { PRODUCT_LIST_PATH } from "@design-lab/shared/constants/constants";
import {
  trackChangeShirtButtonOpened,
  trackChangeShirtModalClosed
} from "@design-lab/shared/lib/analytics";

type ChangeShirtProps = {
  children?: (props: { openProductBrowser: () => void }) => React.ReactNode;
  icon?: React.ReactNode;
  size?: "lg" | "sm";
  className?: string;
};

export function ChangeShirt(props: ChangeShirtProps) {
  const { children, icon, size = "lg", className = "w-full" } = props;
  const [isProductBrowserOpen, setIsProductBrowserOpen] = useState(false);

  const handleChangeShirt = () => {
    trackChangeShirtButtonOpened();
    setIsProductBrowserOpen(true);
  };

  const handleClose = () => {
    trackChangeShirtModalClosed();
    setIsProductBrowserOpen(false);
  };

  return (
    <>
      {children?.({ openProductBrowser: handleChangeShirt }) || (
        <Button
          data-testid="change-shirt-button"
          variant="outline"
          size={size}
          className={className}
          onPress={handleChangeShirt}
        >
          {icon || (
            <Shirt width={24} height={24} fill="#1F2937" className="mr-1 !h-[24px] !w-[24px]" />
          )}
          Switch Product
        </Button>
      )}

      <ProductBrowser
        url={`${PRODUCT_LIST_PATH}&replace=true`}
        title="Change Product"
        isOpen={isProductBrowserOpen}
        onClose={handleClose}
      />
    </>
  );
}
